var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grouped__wrapper"},_vm._l((_vm.messages),function(m,i){return _c('message',{key:m.message_ts,attrs:{"message":m,"message-thread-id":_vm.messageThreadId,"is-feed":_vm.isFeed,"is-self":_vm.isSelf,"is-same-as-prev":"","is-in-group":"","is-last":_vm.messages.length - 1 === i,"is-first":i === 0,"group-key":_vm.groupKey},on:{"openImage":function (ref) {
                var imageId = ref.imageId;

                return _vm.$emit('openImage', { imageId: imageId, groupId: _vm.lightboxGroupKey });
}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }